import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle as farUserCircle } from '@fortawesome/free-regular-svg-icons';
import useUserStore from '../../../store/userStore';
import { useNavigate } from 'react-router-dom';
import LoginPopup from '../../LoginPopup/LoginPopup';
import AccountMenuContext from '../AccountMenuContext/AccountMenuContext';
import './MobileAccount.scss'
const MobileAccount = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const { user, isAuthenticated, logout } = useUserStore(); 
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const navigate = useNavigate();

  const openLoginPopup = () => setIsLoginPopupOpen(true); 
  const closeLoginPopup = () => setIsLoginPopupOpen(false); 

  const handleLogout = () => {
    logout(); 
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    if (isAuthenticated) {
      setIsMenuOpen(!isMenuOpen);
    } else {
      setIsLoginPopupOpen(true);
    }
  };

  return (
    <div className='search-bar-mobile'>
      <FontAwesomeIcon 
        icon={farUserCircle} 
        className={`mob-account-icon ${isAuthenticated ? 'authenticated-user' : ''}`}
        onClick={()=>toggleMenu()}
      />
      
      {isAuthenticated && isMenuOpen && (
        <AccountMenuContext 
          onClose={() => setIsMenuOpen(false)}
          onLogout={handleLogout}
          username={user?.username}
        />
      )}
      
      {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}
    </div>
  );
};

export default MobileAccount;